import { jsx as _jsx } from "react/jsx-runtime";
import { ChipStyled } from './PickAllAvailableQuantityChip.styled';
export const PickAllAvailableQuantityChip = ({ availableQuantity, onClick, ...props }) => {
    return _jsx(ChipStyled, { variant: "filled", shape: "circle", color: "primary", ...props, label: availableQuantity, onClick: onClick });
};
